import {
    GET_INSEMINATION_SUCCESS_REQUEST,
    GET_INSEMINATION_SUCCESS_SUCCESS,
    GET_INSEMINATION_SUCCESS_FAILURE,
} from "./constants";

export interface IState {
    startDate: Date;
    stopDate: Date;
    gotData: boolean;
    loading: boolean;
    error: null | string;
    data: any;
}

export const initialState: any = {
    gotData: false,
    loading: false,
    error: null,
    startDate: new Date(),
    stopDate: new Date(),
    scoreData: [],
};

export const InseminationSuccessReducer = (state: any = initialState, action: any) => {
    switch (action.type) {
        case GET_INSEMINATION_SUCCESS_REQUEST:
            return {
                ...state,
                gotData: false,
                loading: true,
                error: null,
            };
        case GET_INSEMINATION_SUCCESS_SUCCESS:

            const newState = {
                ...state,
                loading: false,
                gotData: true,
                scoreData: action.payload.scoreData,
            };

            return newState;

        case GET_INSEMINATION_SUCCESS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
